/* eslint-disable no-param-reassign, func-names, prefer-arrow-callback, object-shorthand */
export default function mapGetSet ({ get, set, keys }) {
  return keys.reduce(function (a, k) {
    a[k] = {
      get: function () { return get(this, this.$store, k) },
      set: function (v) { set(this, this.$store, k, v) },
    }
    return a
  }, {})
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/libs/map-get-set.js